export default __webpack_public_path__ + "images/319055364a065f8d036d63d3a678c408.png";